webpackJsonp([188301781602599],{

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Mentors = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(565);
	
	var _Modal = __webpack_require__(21);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(19);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(16);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(17);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _mentors = __webpack_require__(65);
	
	var _mentors2 = _interopRequireDefault(_mentors);
	
	var _knowledgeCenter = __webpack_require__(44);
	
	var _knowledgeCenter2 = _interopRequireDefault(_knowledgeCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamModal = function TeamModal(_ref) {
		var activeItem = _ref.activeItem,
		    show = _ref.show,
		    onHide = _ref.onHide;
	
		return _react2.default.createElement(
			_Modal2.default,
			{ direction: '', className: 'teamdetails__wrapper', show: show, onHide: onHide },
			_react2.default.createElement(
				_Modal2.default.Header,
				null,
				_react2.default.createElement(
					'div',
					{ className: 'head_section' },
					_react2.default.createElement(
						'span',
						{ className: 'item_name' },
						activeItem.name
					),
					_react2.default.createElement(
						'div',
						{ className: 'item_des' },
						activeItem.post
					),
					_react2.default.createElement(
						'div',
						{ className: 'item_des' },
						activeItem.cmp
					)
				),
				_react2.default.createElement(
					'span',
					{ className: 'cross pull-right' },
					_react2.default.createElement('i', { onClick: onHide, className: 'fa fa-times' })
				)
			),
			_react2.default.createElement(
				_Modal2.default.Body,
				null,
				_react2.default.createElement(
					'div',
					{ className: 'item__desc' },
					_react2.default.createElement('div', { className: 'item__desc_scr', style: { padding: "0px 10px 0px 0px" }, dangerouslySetInnerHTML: { __html: activeItem.desc } })
				)
			),
			_react2.default.createElement(_Modal2.default.Footer, null)
		);
	};
	
	TeamModal.propTypes = {
		activeItem: _propTypes2.default.object,
		show: _propTypes2.default.object,
		onHide: _propTypes2.default.object
	};
	
	var Mentors = exports.Mentors = function (_React$Component) {
		_inherits(Mentors, _React$Component);
	
		function Mentors(args) {
			_classCallCheck(this, Mentors);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
			_this.togglePopUp = function (item) {
				_this.setState({
					isShow: !_this.state.isShow,
					activeItem: item || {}
				});
			};
	
			_this.state = {
				activeItem: {},
				isShow: false
			};
			return _this;
		}
	
		Mentors.prototype.render = function render() {
			var _this2 = this;
	
			var location = this.props.location;
			var isShow = this.state.isShow;
	
			return _react2.default.createElement(
				_contentPage2.default,
				null,
				_react2.default.createElement(_meta2.default, { title: 'Winpe ProClub Mentorship Program | Mentors', description: 'Our mentors include eminent industry leaders who have had a rich professional and leadership journey and who are now keen to support the growth of female talent into future leaders.', image: "https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg", location: location }),
				_react2.default.createElement(
					'div',
					{ className: 'mentors-wrapper' },
					_react2.default.createElement(
						'section',
						{ id: 'team', className: 'pb-5' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'h1',
								{ className: 'section-title h1' },
								'Mentors',
								_react2.default.createElement('br', null),
								'Cohort I'
							),
							_react2.default.createElement(
								'div',
								{ className: 'section_intro_text' },
								'Our mentors include eminent industry leaders who have had a rich professional and leadership journey and who are now keen to support the growth of female talent into future leaders.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_mentors2.default.map(function (item, i) {
									return _react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-sm-6 col-md-4' },
										_react2.default.createElement(
											'div',
											{ className: '' },
											_react2.default.createElement(
												'div',
												{ className: 'mainflip flip-0', style: { minHeight: '450px' } },
												_react2.default.createElement(
													'div',
													{ className: 'frontside' },
													_react2.default.createElement(
														'div',
														{ className: 'card' },
														_react2.default.createElement(
															'div',
															{ className: 'card-body text-center mt-4' },
															_react2.default.createElement(
																'p',
																null,
																_react2.default.createElement('img', { onClick: function onClick() {
																		return _this2.togglePopUp(item);
																	}, className: ' img-fluid', src: item.imgUrl, alt: item.name })
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_title' },
																item.name
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text1' },
																item.post
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text1' },
																item.cmp
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text', style: { height: 'auto' } },
																item.cohort
															),
															_react2.default.createElement(
																'a',
																{ target: '_blank', href: item.link, className: 'btn btn-primary btn-sm' },
																_react2.default.createElement('i', { className: 'fa fa-linkedin' })
															)
														)
													)
												)
											)
										)
									);
								}),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 col-sm-6 col-md-4' },
									_react2.default.createElement(
										'div',
										{ className: '' },
										_react2.default.createElement(
											'div',
											{ className: 'mainflip flip-0' },
											_react2.default.createElement(
												'div',
												{ className: 'frontside' },
												_react2.default.createElement(
													'div',
													{ className: 'card' },
													_react2.default.createElement(
														'div',
														{ className: 'card-body text-center mt-4' },
														'\xA0'
													)
												)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(TeamModal, { show: isShow, onHide: this.togglePopUp, activeItem: this.state.activeItem })
					)
				)
			);
		};
	
		return Mentors;
	}(_react2.default.Component);
	
	Mentors.propTypes = {
		location: _propTypes2.default.object
	};
	
	exports.default = Mentors;

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cohort-i-mentors-index-jsx-dd635d3c41fdfb094e6a.js